import { captureException } from "@sentry/browser";
import SystemOneApp from "common/SystemOneApp";
import React, { useEffect } from "react";
import { Message } from "components/Atoms/Message";
import { useRouteError } from "react-router";

export function ErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    console.error(error);
    captureException(error);
  }, []);

  return <SystemOneApp>
    <Message type="error">
      <span dangerouslySetInnerHTML={{ __html: RESX.ExceptionMessage.ThereWasAnError }} />
    </Message>
  </SystemOneApp>
}
